const initialState = {
	currentUser: null,
	loading: false,
	errors: null,
};

export default initialState;
